/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_carpets_change_icon = /** @type {(inputs: {}) => string} */ () => {
	return `Cambiar ícono`
};

const en_cards_carpets_change_icon = /** @type {(inputs: {}) => string} */ () => {
	return `Change icon`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_carpets_change_icon = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_carpets_change_icon(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_carpets_change_icon", locale)
	if (locale === "es") return es_cards_carpets_change_icon(inputs)
	return en_cards_carpets_change_icon(inputs)
};
export { cards_carpets_change_icon as "cards.carpets.change_icon" }